export default (function (array) {
  return array[array.length - 1];
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/getLastElement.js
// module id = 2758
// module chunks = 0